import {
    defaultBaseQuery,
    transformErrorResponse,
    transformSuccessResponse,
    buildFormData
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const specialachievementapi = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'specialachievementapi',
    endpoints: (builder) => ({
        getSpecialAchievements: builder.query({
            query: () => ({
                url: `/student/special-achievement`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getSpecialAchievementById: builder.query({
            query: (achievementId) => ({
                url: `/student/special-achievement/${achievementId}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        addSpecialAchievement: builder.mutation({
            query: ({ requestDTO, certificate }) => ({
                url: '/student/special-achievement/add',
                method: 'POST',
                body: buildFormData({ requestDTO, certificate })
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        updateSpecialAchievement: builder.mutation({
            query: ({ requestDTO, certificate }) => ({
                url: '/student/special-achievement/update',
                method: 'POST',
                body: buildFormData({ requestDTO, certificate })
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        deleteSpecialAchievement: builder.mutation({
            query: (achievementId) => ({
                url: `/student/special-achievement/delete`,
                method: 'DELETE',
                params: {
                    achievementId
                }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    }),
});

export const {
    useLazyGetSpecialAchievementsQuery,
    useLazyGetSpecialAchievementByIdQuery,
    useAddSpecialAchievementMutation,
    useUpdateSpecialAchievementMutation,
    useDeleteSpecialAchievementMutation
} = specialachievementapi;

export default specialachievementapi;
